import { render } from "./MobileSubscribePage.vue?vue&type=template&id=2493fcbe&scoped=true"
import script from "./MobileSubscribePage.vue?vue&type=script&lang=js"
export * from "./MobileSubscribePage.vue?vue&type=script&lang=js"

import "./MobileSubscribePage.vue?vue&type=style&index=0&id=2493fcbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2493fcbe"]])

export default __exports__